import { render, staticRenderFns } from "./SpaceActivitiesAccordion.vue?vue&type=template&id=30b067ae&scoped=true"
import script from "./SpaceActivitiesAccordion.vue?vue&type=script&lang=ts"
export * from "./SpaceActivitiesAccordion.vue?vue&type=script&lang=ts"
import style0 from "./SpaceActivitiesAccordion.vue?vue&type=style&index=0&id=30b067ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b067ae",
  null
  
)

export default component.exports